import React from "react";
import Logo from "../Logo";

function Header({ children }) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex w-2/5">
        <span>{/* N participants? */}</span>
      </div>
      <div className="flex w-1/5 py-1 justify-center">
        <Logo className="h-6 w-auto" />
      </div>
      <div className="flex w-2/5 justify-end">
        {/* General actions */}
        {children}
      </div>
    </div>
  );
}

export default Header;
